import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration from environment variables
const firebaseConfig = {
 apiKey: "AIzaSyA-4ieVZuP6Q2uIMR4B8A9IeZ92JnU2_SU",
  authDomain: "ppsrnp-ph.firebaseapp.com",
  projectId: "ppsrnp-ph",
  storageBucket: "ppsrnp-ph.firebasestorage.app",
  messagingSenderId: "85781937259",
  appId: "1:85781937259:web:59e2c701d4cd5d014e452e",
  measurementId: "G-492149JTT2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
export default app;